import React from 'react';
import PropTypes from 'prop-types';

import {
  Container,
  EmailText,
} from './ConfirmationModal.styles';

const ConfirmationModal = ({ data }) => {
  return (
    <Container>
      {data.text}
      <EmailText>{data.emailText}</EmailText>
    </Container>
  );
};

ConfirmationModal.propTypes = {
  data: PropTypes.object.isRequired,
};

export default ConfirmationModal;

